import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { ContentMessage } from 'axway-react-ui';
import IntlComponent from 'axway-react-intl';

class InstallConfirmView extends React.Component {
	constructor(props) {
		super(props);
		IntlComponent.init(this);
	}

	render() {
		const summary = this.intl.formatMsg('This community plugin is not directly supported by Axway and is supported by its publisher. If installed, it is without Axway support or warranty.');
		return (
			<ContentMessage
				confirm
				actionClass="btn-primary"
				onClose={this.props.cancelInstallRequest}
				summary={summary}
				className="lg warning"
				imgClass="gg icon-GG-warning"
				onAction={this.props.installComponent}
				actionLabel={this.intl.formatMsg('Agree and install')}
				cancelLabel={this.intl.formatMsg('Cancel')}
			/>
		);
	}
}

InstallConfirmView.propTypes = {
	installComponent: PropTypes.func.isRequired,
	cancelInstallRequest: PropTypes.func.isRequired
};

export default injectIntl(InstallConfirmView);
